import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import authAndAddAccount from './actions/authAndAddAccount';

export { getProviderFromAccountType } from './utils/getProviderFromAccountType';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AccountConfig" */ './lazyIndex')
);

// Register orchestrators
registerLazyOrchestrator(authAndAddAccount, lazyModule, m => m.authAndAddAccountOrchestrator);

export let lazyLaunchAccountConfigDialog = new LazyAction(
    lazyModule,
    m => m.launchAccountConfigDialog
);
